/** Pure function: given a profile, returns a Set of visible field keys. */
export function visibleFields(profile) {
  const v = new Set()

  v.add('situation_civile')
  v.add('profession')

  if (profile.civilStatus === 'marie') {
    v.add('regime_matrimonial')
    v.add('profession_conjoint')
    v.add('clause_beneficiaire_conjoint')
  } else if (profile.civilStatus === 'pacse') {
    v.add('profession_conjoint')
  } else {
    v.add('pacs_concubinage')
  }

  if (profile.hasChildren) {
    v.add('enfants')
    v.add('etudes_enfants')
  } else if (profile.civilStatus === 'celibataire') {
    v.add('personnes_a_charge')
  }

  if (profile.employment === 'salarie') v.add('capacite_epargne_mensuelle')
  if (profile.employment === 'independant') {
    v.add('charges_independant')
    v.add('capacite_epargne_mensuelle')
  }
  if (profile.employment === 'dirigeant') {
    v.add('parts_sociales')
    v.add('capacite_epargne_mensuelle')
  }
  if (profile.employment === 'retraite') {
    v.add('pension_mensuelle')
  }

  if (profile.ownership === 'proprietaire') v.add('residence_principale_valeur')
  if (profile.ownership === 'locataire')    v.add('loyer_mensuel')

  v.add('tmi')
  v.add('horizon')
  v.add('profil_risque')

  return v
}
